import * as React from "react";

import * as Api from "lib/api";
import * as QueryString from "query-string";
import { IBaseProps } from "lib/data/interfaces";
import "./SearchHeader.less";
import Search from "antd/lib/input/Search";
import { Button } from "antd";
import { RouteComponentProps } from "react-router";
import { SearchBar } from "../SearchBar";
import { SearchPage } from "components/pages";

interface ISearchHeaderProps extends RouteComponentProps<any> {
	component: React.ComponentType<RouteComponentProps>;
}

interface ISearchHeaderState {

	title: string;
}

export class SearchHeader extends React.Component<ISearchHeaderProps, ISearchHeaderState> {

	public constructor(props: ISearchHeaderProps) {

		super(props);

		this.state = {
			title: "Government Directory"
		};
	}

	public async componentDidMount() {

		const content = await Api.ContentManagementApi.getHomeContent();

		if (content) {
			this.setState({ title: content.title });
		}
	}

	public render() {

		const searchQueryString = QueryString.parse(this.props.location.search).q;
		let searchQuery: string | undefined;

		if (searchQueryString) {

			// Check If Query Returns Multiple
			if (Array.isArray(searchQuery)) {

				// Concatenate Search Queries
				searchQuery = searchQuery.join(" ");
			}
			else {

				// Store Search Query As-Is
				searchQuery = searchQueryString as string;
			}
		}

		const className = `search-header`;

		return (
			<section className={className}>
				{/* <h3>{this.state.title}</h3> */}
				<div className="search-bar-container">
					{/* <Search
						placeholder={`Search ${this.state.title}`}
						enterButton={true}
						size="large"
						onSearch={value => console.log(value)}
					/> */}
					<SearchBar
						placeholder="What are you looking for today?"
						onSearch={this.onDirectorySearched}
						searchString={searchQuery}
						title={this.state.title}
					/>
				</div>
				<div className="search-bar-content-container">
					{React.createElement(this.props.component, this.props)}
				</div>
			</section>
		);
	}

	private onDirectorySearched = (searchString: string) => {
		// Redirect To Search Page
		this.props.history.push(`${SearchPage.BasePath}?q=${searchString}`);
	}
}
